import a, { AxiosPromise } from 'axios'
import API from './API'
import User from 'model/User'

export default class Auth {
  public static getCurrentUser (): AxiosPromise<User> {
    return a.get(API.auth + '/currentUser')
  }
}
